import StarIcon from '@mui/icons-material/Star';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const RatingDistributionCard = ({ averageReview, starDistribution, reviewCount }) => {
  // Check if `starDistribution` is defined and has length before proceeding
  if (!starDistribution || reviewCount === 0) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <Stack spacing={1}>
          <Typography
            component="p"
            sx={{ textAlign: { md: 'flex-start', xs: 'center' } }}
            variant="h6"
          >
            <FormattedMessage id="ListingPage.ratingDistributionHeading" />
          </Typography>

          <Box
            sx={{
              backgroundColor: '#F1F3F4',
              borderRadius: '65px',
              padding: '0.25em 0.5em 0.25em 0.5em',
              display: 'flex',
              flexDirection: 'row',
              alignSelf: 'center',
              alignItems: 'center',
            }}
          >
            <Rating precision={0.1} readOnly sx={{ color: '#EAC435' }} value={averageReview} />
            <Typography
              ml={1}
              sx={{ textAlign: { md: 'flex-start', xs: 'center' } }}
              variant="body1"
            >
              {averageReview.toFixed(1)}
            </Typography>
          </Box>

          <Typography
            sx={{ display: 'block', textAlign: { md: 'flex-start', xs: 'center' } }}
            variant="p3"
          >
            <FormattedMessage
              id="ProfilePage.reviewsOfProviderTitle"
              values={{ count: reviewCount }}
            />
          </Typography>

          <Box>
            <Stack spacing={0.5}>
              {starDistribution
                .slice()
                .reverse()
                .map((count, index) => {
                  const percentage = (count / reviewCount) * 100;
                  const starRating = 5 - index;
                  const ariaLabel = `${starRating} stars, ${Math.round(percentage)}% of reviews`;

                  return (
                    <Box
                      key={index}
                      style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5em' }}
                    >
                      <Typography style={{ marginRight: '1em' }} variant="body1">
                        <StarIcon color="primary" /> {5 - index}
                      </Typography>
                      <LinearProgress
                        aria-label={ariaLabel} // Add aria-label to LinearProgress
                        style={{
                          flexGrow: 1,
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          borderRadius: '0.25em',
                          marginRight: '1em',
                        }}
                        value={percentage}
                        variant="determinate"
                      />
                      <Typography variant="body1">{Math.round(percentage)}%</Typography>
                    </Box>
                  );
                })}
            </Stack>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default React.memo(RatingDistributionCard);
